<template>
  <div>
    <!-- Confirmation Prompt -->
    <vs-prompt
      title="Deactivate User from Organization"
      @accept="deactivateUser"
      accept-text="Confirm"
      :active.sync="confirmUserDeactivation"
    >
      <div>
        Are you sure, you want to deactivate
        <b>{{ firstName }}</b>
        from this Organization?
      </div>
    </vs-prompt>

    <!-- Tooltip Wrapper -->
    <vs-tooltip text="Deactivate User" position="top">

      <vs-button
  class="delete-btn"
  @click.stop="confirmUserDeactivation = true"
  :disabled="deactivationInProgress"
>

  <vs-icon
    icon="delete"
    size="16px"
    class="delete-icon"
  />

</vs-button>

    </vs-tooltip>

    <!-- Progress text -->
    <span v-if="deactivationInProgress" style="color: red; font-size: 12px;">
      Deactivation In Progress...
    </span>

  </div>
</template>

<script>
export default {
  props: ["firstName", "employeeId"],

  data() {
    return {
      confirmUserDeactivation: false,
      deactivationInProgress: false,
    };
  },

  computed: {

    buttonColor() {
      return this.deactivationInProgress ? "warning" : "danger";
    },

    buttonIcon() {
      return this.deactivationInProgress
        ? "hourglass_empty"
        : "delete";
    }

  },

  methods: {

    deactivateUser() {

      this.deactivationInProgress = true;

      this.$store.dispatch("organization/deactivateEmployee", {
        employeeId: this.employeeId,
      });

    },

  },

};
</script>
<style scoped>

.delete-btn {

  background: transparent !important;
  border: none !important;

  width: 32px;
  height: 32px;

  border-radius: 50% !important;

  display: inline-flex !important;
  align-items: center;
  justify-content: center;

  padding: 0 !important;

  transition: background 0.25s ease;

}

.delete-icon {

  color: #EA5455 !important;
  font-size: 18px;
  transition: color 0.25s ease;

}


/* HOVER → ROUND RED CIRCLE */

.delete-btn:hover {

  background: #EA5455 !important;

}

.delete-btn:hover .delete-icon {

  color: #ffffff !important;

}

</style>